import { InjectionToken, Provider } from '@angular/core';
import { RemoteIntegrationMountProps } from '../models/remote-integration-module';

/**
 * Injection token for mount props shared with every mounted integration.
 * Shared props are merged with the `mountProps` configured on each integration config.
 */
export const RemoteIntegrationSharedMountProps = new InjectionToken<RemoteIntegrationMountProps>('RemoteIntegrationSharedMountProps', {
  providedIn: 'root',
  factory: (): RemoteIntegrationMountProps => ({}),
});

/** Provides shared mount props for all integrations using a factory function. */
export const provideRemoteIntegrationSharedMountProps = (factory: () => RemoteIntegrationMountProps): Provider => ({
  provide: RemoteIntegrationSharedMountProps,
  useFactory: factory,
});
